/**
 * The backend can return training dependency warnings as strings or objects.
 * This explicit normalisation keeps React from attempting to render an object,
 * while never displaying raw payloads, credentials or certificate contents.
 */
export const trainingDependencyWarningText = warning => {
  if (typeof warning === 'string') return warning;
  if (warning && typeof warning === 'object') {
    const value = warning.message || warning.reason || warning.detail || warning.code;
    return typeof value === 'string' && value.trim()
      ? value : 'Training evidence requires an additional review.';
  }
  return 'Training evidence requires an additional review.';
};
